import React from 'react';
import { LoanApprovalDataProvider } from './LoanApprovalDataProvider';
import LoanSupervisorReviewView from './LoanSupervisorReviewView';

interface LoanSupervisorReviewViewWithProviderProps {
  data?: any;
  formikProps?: any;
  onSubmit?: (values: any) => void;
}

/**
 * LoanSupervisorReviewViewWithProvider - Wrapper component that provides loan balance data
 * to LoanSupervisorReviewView through the LoanApprovalDataProvider context.
 * 
 * This component should be used in approval workflows instead of LoanSupervisorReviewView directly.
 */
const LoanSupervisorReviewViewWithProvider: React.FC<LoanSupervisorReviewViewWithProviderProps> = (props) => {
  return (
    <LoanApprovalDataProvider
      valueData={props.formikProps?.values?.valueData || props.data?.valueData}
      data={props.data}
      formikProps={props.formikProps}
    >
      <LoanSupervisorReviewView {...props} />
    </LoanApprovalDataProvider>
  );
};

export default LoanSupervisorReviewViewWithProvider;
